import Cal, { getCalApi } from '@calcom/embed-react'
import { useEffect, useRef } from 'react'

interface CalcomProps {
    height?: string
    width?: string
    onBookingSuccess?: () => void
    successRedirectUrl?: string
}

export default function Calcom({
    height = '100%',
    width = '100%',
    onBookingSuccess,
}: CalcomProps) {
    const duration = import.meta.env.VITE_CAL_DURATION || '30min'
    const calLink = `${import.meta.env.VITE_CAL_USERNAME}/${duration}`
    const onBookingSuccessRef = useRef(onBookingSuccess)
    const isInitialized = useRef(false)

    // Keep the ref updated with the latest callback
    useEffect(() => {
        onBookingSuccessRef.current = onBookingSuccess
    }, [onBookingSuccess])

    useEffect(() => {
        // Prevent multiple initializations
        if (isInitialized.current) return

        const initCal = async () => {
            const cal = await getCalApi({ namespace: duration })

            cal('on', {
                action: 'bookingSuccessful',
                callback: (e: any) => {
                    console.log(
                        'Booking successful - executing once:',
                        e.detail
                    )
                    setTimeout(() => {
                        // Use the ref to get the latest callback
                        onBookingSuccessRef.current?.()
                    }, 1000)
                },
            })

            cal('on', {
                action: 'linkReady',
                callback: () => console.log('Cal.com embed is ready'),
            })

            cal('on', {
                action: 'bookingCancelled',
                callback: (e: any) =>
                    console.log('Booking was cancelled:', e.detail),
            })

            isInitialized.current = true
        }

        initCal()

        // Cleanup
        return () => {
            isInitialized.current = false
        }
    }, [duration]) // Only depend on duration

    return (
        <div style={{ height, width }}>
            <Cal
                namespace={duration}
                calLink={calLink}
                style={{
                    width: '100%',
                    height: '100%',
                    overflow: 'scroll',
                }}
                config={{
                    layout: 'month_view',
                }}
            />
        </div>
    )
}
